export default "__VITE_ASSET__BsL56a9R__"